import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {UIModule} from "../ui/ui.module";
import {SelectDropDownModule} from "ngx-select-dropdown";
import {TextInputAutocompleteModule} from "ngx-input-autocomplete";
import { EmailEditorComponent } from './email-editor/email-editor.component';
import { PaymentEditorComponent } from './payment-editor/payment-editor.component';
import { VOCEditorComponent } from './voc-editor/voc-editor.component';
import { JvUiModule } from '../../../../projects/jv-ui/src/lib/jv-ui.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UIModule,
    SelectDropDownModule,
    TextInputAutocompleteModule,
    JvUiModule
  ],

  declarations: [
    EmailEditorComponent,
    PaymentEditorComponent,
    VOCEditorComponent
  ],

  entryComponents: [
    EmailEditorComponent,
    PaymentEditorComponent,
    VOCEditorComponent
  ],
})
export class PopupsModule {
}
